"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class AggregateTelemetry extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetConsumption';
        this.isListening = true;
        this._consumption = initParams.consumption;
        this._siteId = initParams.site_id;
        this._time = initParams.time;
    }
    set consumption(value) {
        console.error('Do not set objects this way');
    }
    get consumption() {
        return this._consumption;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    get siteId() {
        return this._siteId;
    }
    set time(value) {
        console.error('Do not set objects this way');
    }
    get time() {
        return this._time;
    }
}
exports.default = AggregateTelemetry;
//# sourceMappingURL=aggregateTelemetry.js.map